/*  ========================================================================
    # Scripts - Video Handling
    ========================================================================  */

/**
 * Script to handle video Handling.
 */

const VideoHandling = {
  cfg: {
    videoContainer: document.querySelectorAll('.s-image-video__video-wrapper--onclick')
  },

  handleVideoClick() {
    this.cfg.videoContainer.forEach(container => {
      const toggle = container.querySelector('.s-image-video__video-toggle');
      const video = container.querySelector('#' + toggle.dataset.target);

      toggle.addEventListener('click', () => {
        if (video) {
          container.classList.add('play');
          video.play();
        }
      });
    });
  },

  /**
   * Initialize.
   */
  init() {
    if (this.cfg.videoContainer.length > 0) {
      this.handleVideoClick();
    }
  }
};

export default VideoHandling;
